interface LogoProps {
  className?: string;
  /**
   * "dark"  → green wordmark, for light backgrounds (scrolled navbar)
   * "light" → light wordmark, for dark backgrounds (hero, footer)
   */
  variant?: "dark" | "light";
}

const LOGO_SRC = {
  dark: "https://public.readdy.ai/ai/img_res/483c52c1-c015-4be3-adb2-86e0eed80a30.png",
  light: "https://public.readdy.ai/ai/img_res/86bf967a-fb5f-4fd9-84a7-e1a36fff78a9.png",
};

export default function Logo({ className = "", variant = "dark" }: LogoProps) {
  return (
    <span className={`inline-flex items-center justify-center ${className}`}>
      <img
        src={LOGO_SRC[variant]}
        alt="DJT EV Power Tech · Green Steel logo"
        title="DJT EV Power Tech · Green Steel"
        className="h-14 w-auto object-contain md:h-20"
      />
    </span>
  );
}